import { withPublicWrapper } from '../components/public/Wrapper/withPublicWrapper';
import React from 'react';
import IntroBlock from 'components/public/Intro/IntroBlock';
import { Col, Divider } from 'antd';
import ContactForm from 'components/ContactForm';
import Pricing from 'components/Pricing';

const PricingPage = (): JSX.Element => {
  return (
    <>
      <Pricing freeTrailLink={'/hitch/off-the-shelf'} />
      <IntroBlock
        type="white"
        description={
          <Col>
            <Divider orientation="center">Want to know more? Contact us</Divider>
            <ContactForm />
          </Col>
        }
      />
    </>
  );
};

export default withPublicWrapper(PricingPage);
